module.exports = __webpack_public_path__ + "img/1_022.c8a18818.jpg";